import StarBorderIcon from "@mui/icons-material/StarBorderRounded";
import StarIcon from "@mui/icons-material/StarRounded";
import {
  Rating as MuiRating,
  RatingProps as MuiRatingProps,
} from "@mui/material";
import React from "react";

type Props = Pick<MuiRatingProps, "defaultValue" | "readOnly" | "onChange"> & {
  size?: "small" | "medium" | "large" | number;
};

export default function Rating(props: Props): React.ReactElement {
  const { defaultValue, readOnly = false, size = "medium", onChange } = props;

  const [Icon, EmptyIcon] = React.useMemo(() => {
    if (size === "small" || size === "medium" || size === "large") {
      return [<StarIcon fontSize={size} />, <StarBorderIcon fontSize={size} />];
    }
    if (typeof size === "number") {
      return [
        <StarIcon
          sx={{
            fontSize: size,
          }}
        />,
        <StarBorderIcon
          sx={{
            fontSize: size,
          }}
        />,
      ];
    }
  }, [size]);

  return (
    <MuiRating
      readOnly={readOnly}
      defaultValue={defaultValue}
      precision={0.5}
      icon={Icon}
      emptyIcon={EmptyIcon}
      onChange={onChange}
    />
  );
}
